/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Badge,
  BadgeProps,
  Tooltip,
} from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';

const ReviewNotificationBadge = ({
  badgeProps = {},
  useIcon = false,
}: {
  badgeProps?: BadgeProps;
  useIcon?: boolean;
}) => (
  <Tooltip
    title="Submit a review for your trip"
    placement="top-start"
  >
    <>
      {useIcon && <OutlinedIcons.OutlinedExclamationCircleIcon fontSize="small" color="info" />}
      {!useIcon && (
        <Badge
          badgeContent={<OutlinedIcons.OutlinedExclamationCircleIcon fontSize="small" />}
          color="info"
          {...badgeProps}
          sx={{
            ...badgeProps && badgeProps.sx,
          }}
        />
      )}
    </>
  </Tooltip>
);

export default ReviewNotificationBadge;
